// Utils
import { findObjectWithId, isObjectId } from '../../objectIdentity';
/**
 * For the given values, if the value is an encoded object reference, return the associated object
 * from the given values. Or the object map containing yet to be incorporated objects.
 * Otherwise do nothing and return the value given.
 *
 * @param {any} value
 * @param {T} values
 * @param {ObjectMap} newObjects
 *
 * @return {any}
 */
export var resolveObjectIdsToCurrentValue = function (value, values, newObjects) {
    var newValue;
    if (typeof value === 'string' && isObjectId(value)) {
        var objectAddition = newObjects[value];
        if (objectAddition !== undefined) {
            newValue = objectAddition;
        }
        if (newValue === undefined) {
            newValue = findObjectWithId(values, value);
        }
    }
    else {
        newValue = value;
    }
    return newValue;
};
//# sourceMappingURL=resolveObjectIdsToCurrentValue.js.map